import React from "react";
import "./Testimonials.css";

function Testimonials() {
  return (
    <section id="testimonials" className="testimonials">
      <div className="container">
        <h2>O que dizem nossos clientes</h2>
        <div className="testimonial-list">
          <div className="testimonial-item">
            <p>"A Inti transformou a gestão do meu negócio, tornando tudo mais simples e prático!"</p>
            <h4>Mariana, Empresária</h4>
          </div>
          <div className="testimonial-item">
            <p>
              "Consegui acesso a crédito de forma rápida e com condições que realmente ajudam no crescimento da minha
              empresa."
            </p>
            <h4>Carlos, Proprietário</h4>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
